import React, {Fragment} from 'react';
import {
  VideoOffIcon,
  VideoOnIcon,
  MicOffIcon,
  MicOnIcon,
} from '@100mslive/react-icons';
import {Tooltip, IconButton} from '@100mslive/react-ui';
import {
  useAVToggle,
  parsedUserAgent,
  useHMSActions,
  useHMSStore,
  selectIsLocalAudioEnabled,
  selectIsLocalVideoEnabled,
} from '@100mslive/react-sdk';

const isMacOS = parsedUserAgent.getOS().name.toLowerCase() === 'mac os';

export const AudioVideoToggle = ({compact = false}) => {
  const {isLocalVideoEnabled, isLocalAudioEnabled} = useAVToggle();
  const audioEnabled = useHMSStore(selectIsLocalAudioEnabled);
  const videoEnabled = useHMSStore(selectIsLocalVideoEnabled);
  const hmsActions = useHMSActions();
  async function toggleAudio() {
    await hmsActions.setLocalAudioEnabled(!audioEnabled);
  }

  async function toggleVideo() {
    await hmsActions.setLocalVideoEnabled(!videoEnabled);
  }
  return (
    <Fragment>
      {true ? (
        <Tooltip
          title={`Turn ${audioEnabled ? 'off' : 'on'} audio (${
            isMacOS ? '⌘' : 'ctrl'
          } + d)`}>
          <IconButton
            css={{mr: compact ? '$2' : '$4'}}
            active={audioEnabled}
            onClick={() => {
              toggleAudio();
            }}
            key="toggleAudio"
            data-testid="audio_btn">
            {!audioEnabled ? (
              <MicOffIcon data-testid="audio_off_btn" />
            ) : (
              <MicOnIcon data-testid="audio_on_btn" />
            )}
          </IconButton>
        </Tooltip>
      ) : null}
      {true ? (
        <Tooltip
          title={`Turn ${videoEnabled ? 'off' : 'on'} video (${
            isMacOS ? '⌘' : 'ctrl'
          } + e)`}>
          <IconButton
            css={compact ? {ml: '$2'} : {mx: '$4'}}
            key="toggleVideo"
            active={videoEnabled}
            onClick={toggleVideo}
            data-testid="video_btn">
            {!videoEnabled ? (
              <VideoOffIcon data-testid="video_off_btn" />
            ) : (
              <VideoOnIcon data-testid="video_on_btn" />
            )}
          </IconButton>
        </Tooltip>
      ) : null}
    </Fragment>
  );
};
